import {
  faCommentExclamation,
  faExternalLink,
  faFileDownload,
  faInfoCircle,
  faLink,
  faPlayCircle,
  faQuestionCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import React from 'react';
import type { FormatOptionLabelMeta } from 'react-select-modern';

import * as styles from './CampaignLinksInput.css';

export interface IIconOption {
  id: string;
  name: string;
}

const iconMap = {
  link: faLink,
  'external-link': faExternalLink,
  'comment-exclamation': faCommentExclamation,
  'question-circle': faQuestionCircle,
  'file-download': faFileDownload,
  'play-circle': faPlayCircle,
  'info-circle': faInfoCircle,
};

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatIconOptionLabel(
  data: IIconOption,
  meta: FormatOptionLabelMeta<IIconOption>,
): ReactNode {
  const icon = <FontAwesomeIcon fixedWidth={true} icon={iconMap[data.id]} size={'2x'} />;

  if (meta.context === 'value') {
    return icon;
  }

  return <div className={styles.iconOption}>{icon}</div>;
}
